import $ from 'shared/$';
import mq from 'shared/mq';
import SplitText from 'vendor/SplitText';
import anime from 'animejs';
import { forEach } from 'lodash';

export default class Onboarding {
  constructor(root) {
    this.root = root;
    this.content = this.root.querySelector('.u-card__content');

    const _this = this;

    // mq.register('medium', {
    //   match() {
    //     _this.init();
    //   },
    //   unmatch() {
    //     _this.destroy();
    //   },
    // });

    if (mq.isMoreThan('medium')) {
      this.init();
    }
  }

  init() {
    this.hasSlider = false;

    if (this.root.matches('.u-card--hero')) {
      this.initHero();
    }
    if (this.root.matches('.u-card--full')) {
      this.initFull();
    }
  }

  initHero() {
    this.content.style.clipPath = 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)';
    this.content.style.webkitClipPath = 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)';

    // Check if slider or not
    if (this.root.querySelector('.u-slider')) {
      this.hasSlider = true;
      this.cover = this.root.querySelector('.u-slider');
    } else {
      this.cover = this.root.querySelector('.u-card__cover-inner');
    }
    this.cover.style.clipPath = 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)';
    this.cover.style.webkitClipPath = 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)';

    if (this.hasSlider) {
      this.pagination = this.cover.querySelector('.u-slider__pagination');
      this.pagination.style.opacity = 0;
    }

    this.els = this.content.querySelectorAll('.u-card__content__inner > *');

    setTimeout(this.animeHero.bind(this), 1000);
  }

  animeHero() {
    let objPanel = this.initClip().obj;
    let coordsPanel = this.initClip().coords;

    let objCover = this.initClip().obj;
    let coordsCover = this.initClip().coords;

    const tl = anime.timeline({
      autoplay: false,
    });

    tl
      .add({
        targets: objCover,
        top: [
          { value: 100, duration: 1500, delay: 100, easing: 'easeInOutQuart' },
        ],
        bottom: [
          { value: 100, duration: 1500, delay: 0, easing: 'easeInOutQuart' },
        ],
        update: () => {
          coordsCover[1][0] = objCover.top;
          coordsCover[2][0] = objCover.bottom;

          this.applyClip(this.cover, coordsCover);
        },
      })
      .add({
        targets: objPanel,
        top: [
          { value: 100, duration: 1000, delay: 100, easing: 'easeInOutQuart' },
        ],
        bottom: [
          { value: 100, duration: 1000, delay: 0, easing: 'easeInOutQuart' },
        ],
        update: () => {
          coordsPanel[1][0] = objPanel.top;
          coordsPanel[2][0] = objPanel.bottom;

          this.applyClip(this.content, coordsPanel);
        },
        offset: 400,
      })
      .add({
        targets: this.els,
        opacity: [0, 1],
        translateY: [30, 0],
        duration: 500,
        delay: (target, index) => {
          return index * 100;
        },
        complete: () => {
          this.cleanClip(this.cover);
          this.cleanClip(this.content);
        },
        easing: 'easeOutQuad',
        offset: '-=350',
      });

    if (this.hasSlider) {
      anime({
        targets: this.pagination,
        opacity: [0, 1],
        duration: 500,
        easing: 'easeOutQuad',
        delay: 2500,
        begin: () => {
          this.cleanClip(this.cover);
          this.cleanClip(this.content);
        },
      });
    }

    this.setReady();
    tl.play();
  }

  initFull() {
    this.cover = this.root.querySelector('.u-card__cover-inner');
    this.logo = this.content.querySelector('img');
    this.title = this.content.querySelector('.u-card__content__header__title');
    this.subtitle = this.content.querySelector('.u-card__content__header__subtitle');
    this.text = this.content.querySelector('.u-card__content__text');
    this.link = this.content.querySelector('a');

    this.split = new SplitText(this.title, {
      type: 'words,lines',
      linesClass: 'u-onboarding-line',
      wordsClass: 'u-onboarding-word',
    });

    setTimeout(this.animeFull.bind(this), 1000);
  }

  animeFull() {
    this.cover.style.clipPath = 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)';
    this.cover.style.webkitClipPath = 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)';

    let obj = this.initClip().obj;
    let coords = this.initClip().coords;

    let tlLogo;

    if (mq.isMoreThan('nav')) {
      tlLogo = anime.timeline({
        autoplay: false,
      });

      tlLogo.add({
        targets: this.logo,
        opacity: [0, 1],
        scale: [0.7, 1],
        duration: 4500,
        easing: 'easeOutExpo',
      })
    }

    const tlMain = anime.timeline({
      autoplay: false,
    });

    tlMain
      .add({
        targets: this.split.words,
        translateY: ['100%', 0],
        duration: 500,
        delay: (target, index) => {
          return index * 100;
        },
        easing: 'easeOutQuad',
        offset: mq.isMoreThan('nav') ? 1000 : 0,
      })
      .add({
        targets: this.subtitle,
        translateY: ['100%', 0],
        opacity: [0, 1],
        duration: 350,
        easing: 'easeOutQuad',
      })
      .add({
        targets: this.text,
        translateY: ['100%', 0],
        opacity: [0, 1],
        duration: 350,
        easing: 'easeOutQuad',
      })
      .add({
        targets: this.link,
        translateY: [20, 0],
        opacity: [0, 1],
        duration: 350,
        easing: 'easeOutQuad',
      })
      .add({
        targets: obj,
        top: [
          { value: 100, duration: 1000, delay: 100, easing: 'easeInOutQuart' },
        ],
        bottom: [
          { value: 100, duration: 1000, delay: 0, easing: 'easeInOutQuart' },
        ],
        update: () => {
          coords[1][0] = obj.top;
          coords[2][0] = obj.bottom;

          this.applyClip(this.cover, coords);
        },
        complete: () => {
          this.cleanClip(this.cover);
        },
      });

    this.setReady();

    if (mq.isMoreThan('nav')) {
      tlLogo.play();
    }

    tlMain.play();
  }

  applyClip(el, coords) {
    let a = [];

    forEach(coords, c => {
      const [x, y] = c;
      a.push(`${x}% ${y}%`);
    });

    const str = `polygon(${a.join(',')})`;
    el.style.clipPath = str;
    el.style.webkitClipPath = str;
  }

  cleanClip(el) {
    console.info('cleanClip', el);
    el.style.clipPath = '';
    el.style.webkitClipPath = '';
  }

  initClip() {
    const obj = {
      top: 0,
      bottom: 0,
    };

    const coords = [
      [0, 0],
      [obj.top, 0],
      [obj.bottom, 100],
      [0, 100],
    ];

    return {
      obj: obj,
      coords: coords,
    };
  }

  setReady() {
    this.root.classList.add('is-ready');
  }

  destroy() {
    console.info('Onboarding:destroy');
  }
}
